<template>
  <div class="prosedur align-items-center mx-2">
    <div class="sd-heading align-self-stretch p-2">
      <p class="f-Overpass f-w-600 f-20 my-2 mx-3 align-items-start">
        Cara Top-Up
      </p>
    </div>

    <div
      class="sd-body d-flex flex-column p-a-16 align-items-start align-self-stretch"
    >
      <ul class="content-list f-Overpass f-14 f-w-400">
        <li>Tunjukkan QR Code ke kasir</li>
        <li>Sebutkan nominal top-up yang anda inginkan</li>
        <li>Bayar dengan metode pembayaran yang telah ditentukan</li>
        <li>Cek kembali saldo anda</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "procedureCard",
};
</script>

<style scoped>
.prosedur {
  border-radius: 16px;
  background: var(--primary-white, #fff);
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
}

.sd-heading {
  color: #fff;
  border-radius: 16px 16px 0px 0px;
  background: var(--primary-product-smartlink, #206cfe);
}

.sd-body {
  gap: 10px;
  border-radius: 0px 0px 16px 16px;
}

ul.content-list {
  padding-left: 24px;
}

.content-list li {
  margin-bottom: 10px;
}
</style>
